import '../app.es6';
import angular from 'angular';

class RootController {
  /* @ngInject */
  constructor (
    $rootScope, $location, $scope, $route, $cookies, $window, Resource, GA, sssSharedState,
    SharedState, apiEndpoint, $sessionStorage, LoginType, Page, commonFactory, Const
  ) {
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$route = $route;
    this.$location = $location;
    this.$window = $window;
    this.Resource = Resource;
    this.sharedState = sssSharedState;
    this.uiSharedState = SharedState;
    this.uiSharedState.initialize($scope, 'showLoadingCount', {defaultValue: 0});
    // TODO $rootScope とどちらに設定すべきか今後検討
    this.apiEndpoint = apiEndpoint;
    this.$sessionStorage = $sessionStorage;
    this.Page = Page;
    this.commonFactory = commonFactory;
    this.Const = Const;

    this.$rootScope.$on('$locationChangeSuccess', () => {
      this.$rootScope.actualLocation = $location.path();
    });
    this.$rootScope.$watch(() => {
      return $location.path();
    }, (newLocation, oldLocation) => {
      this.$sessionStorage[this.Const.SSAPP_BROWSER_BACK_FORWARD] = false;
      this.$sessionStorage[this.Const.SSAPP_OLD_LOCATION] = oldLocation;
      if (this.$rootScope.actualLocation === newLocation) {
        this.$sessionStorage[this.Const.SSAPP_BROWSER_BACK_FORWARD] = true;
      }
    });

    RootController.$inject = [
      '$rootScope', '$location', '$scope', '$route', '$cookies', '$window', 'Resource', 'GA',
      'sssSharedState', 'SharedState', 'apiEndpoint', '$sessionStorage',
      'LoginType', 'Page', 'commonFactory', 'Const'
    ];
  }

  isLoading () {
    return this.uiSharedState.get('showLoadingCount') > 0;
  }

  go ($event, url) {
    $event.preventDefault();
    $event.stopPropagation();
    this.$location.path(url);

    // giveup
    this.showLoadingCount = 0;
  }

  toEula () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }
    this.$location.path('/eula');
  }

  toPasswordChange () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }
    this.$location.path('/password_change');
  }

  toNotificationConfigration () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }
    this.$location.path('/notification_configration');
  }

  toHowto () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }
    this.$window.open(this.Const.EXTERNAL_URL.howto, '_blank');
  }

  toCoachingVideos () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }
    this.$window.open(this.Const.EXTERNAL_URL.coachingVideos, '_blank');
  }

}

angular.module('myApp')
.controller('RootController', RootController);



// WEBPACK FOOTER //
// ./app/controllers/root-controller.es6